<div class="sdds-card welcome-page">
    <div class="sdds-card-header">
        <h6 class="sdds-card-headline">Content Template</h6>
        <h6 class="sdds-card-sub-headline">A simple angular front-end project.</h6>
    </div>
</div>